import React, { useState, useEffect } from "react";
import { webEndPoint } from '../constants/globalConstants';
import { makeRequest } from "../services/api";
export default function HeroBanner() {
    const [loading, setLoading] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const [index, setIndex] = useState(0);
    const bannerSlides = dataSource?.filter(
        (slide) => slide.image_type === "Banner"
    ) || [];
    useEffect(() => {
        if (bannerSlides.length === 0) return;
        const interval = setInterval(() => {
            setIndex((prev) => (prev + 1) % bannerSlides.length);
        }, 4000);
        return () => clearInterval(interval);
    }, [bannerSlides.length]);
    const nextSlide = () => {
        if (bannerSlides.length === 0) return;
        setIndex((index + 1) % bannerSlides.length);
    };
    const prevSlide = () => {
        if (bannerSlides.length === 0) return;
        setIndex(index === 0 ? bannerSlides.length - 1 : index - 1);
    };
    const goToSlide = (i) => {
        setIndex(i);
    };
    useEffect(() => {
        fetchBannersData();
    }, []);
    const fetchBannersData = async () => {
        setLoading(true);
        try {
            let url = webEndPoint + "banners";
            const response = await makeRequest("get", url);
            if (response) {
                setDataSource(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    return (
        <div className="hero-container">
            {dataSource
                ?.filter((slide) => slide.image_type === "Banner")
                .map((slide, i) => (
                    <div key={i} className={i === index ? "hero-slide active" : "hero-slide"}>
                        <img src={slide.image_url} alt={slide?.image_type} />
                    </div>
                ))}
            <button className="prev" onClick={prevSlide}>&#10094;</button>
            <button className="next" onClick={nextSlide}>&#10095;</button>
            <div className="dots">
                {dataSource
                    ?.filter((slide) => slide?.image_type === "Banner")
                    .map((_, i) => (
                        <span
                            key={i}
                            className={i === index ? "dot active" : "dot"}
                            onClick={() => goToSlide(i)}
                        ></span>
                    ))}
            </div>
        </div>
    );
}